import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography, Button, Stack } from "@mui/material";
import { alpha } from "@mui/material/styles";
import BlockIcon from "@mui/icons-material/Block";
import { useAuth } from "../../context/AuthContext";
import { brand, shadow, status } from "../../theme/tokens";

const ForbiddenPage = () => {
  const navigate = useNavigate();
  const { user, role, logout } = useAuth();

  const goHome = () => {
    if (role === "superadmin") navigate("/superadmin", { replace: true });
    else if (user) navigate("/dashboard", { replace: true });
    else navigate("/login", { replace: true });
  };

  const handleLogout = async () => {
    await logout();
    navigate("/login", { replace: true });
  };

  return (
    <Box
      sx={{
        minHeight: "100dvh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
        backgroundImage: `linear-gradient(135deg, ${brand.purpleDeep} 0%, ${brand.purple} 100%)`,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: "100%",
          maxWidth: 460,
          p: { xs: 3, sm: 5 },
          borderRadius: 4,
          backgroundColor: "background.paper",
          textAlign: "center",
          boxShadow: shadow.overlay,
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            backgroundColor: alpha(status.error, 0.13),
            color: "error.main",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            mx: "auto",
            mb: 2,
          }}
        >
          <BlockIcon sx={{ fontSize: 40 }} />
        </Box>
        <Typography variant="h5" sx={{ fontWeight: 700, color: "secondary.main", mb: 1 }}>
          Access denied
        </Typography>
        <Typography variant="body1" sx={{ color: "text.secondary", mb: 3 }}>
          Your account role does not have permission to view this page.
        </Typography>
        <Stack direction="row" spacing={1.5} justifyContent="center">
          <Button onClick={goHome} variant="contained" color="secondary">
            Go to my dashboard
          </Button>
          <Button onClick={handleLogout} variant="outlined" color="inherit">
            Log out
          </Button>
        </Stack>
      </Paper>
    </Box>
  );
};

export default ForbiddenPage;
